module.exports = __webpack_public_path__ + "img/image_body-point_02_03.98c4b69e.svg";